<app-modal
  title="Create Rollup Taxonomy"
  subtitle="Define a new rollup to consolidate categories across taxonomies"
  (closed)="closed.emit()"
>
  <!-- Name -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Name</label>
    <input
      type="text"
      placeholder="Type name..."
      [value]="name()"
      (input)="name.set($any($event.target).value)"
      [class.border-red-400]="showErrors() && !name().trim()"
      [class.ring-2]="showErrors() && !name().trim()"
      [class.ring-red-100]="showErrors() && !name().trim()"
      class="w-full"
    />
    @if (showErrors() && !name().trim()) {
      <span class="text-2xs text-red-500">Required</span>
    }
  </div>

  <!-- Definition -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Definition</label>
    <textarea
      placeholder="Type definition..."
      rows="3"
      [value]="definition()"
      (input)="definition.set($any($event.target).value)"
      [class.border-red-400]="showErrors() && !definition().trim()"
      [class.ring-2]="showErrors() && !definition().trim()"
      [class.ring-red-100]="showErrors() && !definition().trim()"
      class="w-full"
    ></textarea>
    @if (showErrors() && !definition().trim()) {
      <span class="text-2xs text-red-500">Required</span>
    }
  </div>

  <!-- Type Toggle -->
  <div class="flex flex-col gap-1.5 mb-5">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Classification Type</label>
    <div class="flex items-center bg-slate-100 rounded-3xl px-1 py-2 gap-1 h-11 w-full">
      <button
        type="button"
        (click)="type.set('situation')"
        class="flex-1 px-4 py-2.5 rounded-full text-xs transition-all cursor-pointer text-center"
        [ngClass]="
          type() === 'situation'
            ? 'bg-white text-navy-900 shadow-sm'
            : 'text-slate-500 hover:text-navy-700'
        "
      >
        Situation Category
      </button>
      <button
        type="button"
        (click)="type.set('response')"
        class="flex-1 px-4 py-2.5 rounded-full text-xs transition-all cursor-pointer text-center"
        [ngClass]="
          type() === 'response'
            ? 'bg-white text-navy-900 shadow-sm'
            : 'text-slate-500 hover:text-navy-700'
        "
      >
        Response Category
      </button>
    </div>
  </div>

  <div modal-footer class="flex items-center justify-end gap-3">
    <button
      type="button"
      (click)="closed.emit()"
      class="px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
    >
      Cancel
    </button>
    <button
      type="button"
      (click)="onSubmit()"
      [disabled]="submitting()"
      class="px-6 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      {{ submitting() ? 'Creating...' : 'Create Rollup' }}
    </button>
  </div>
</app-modal>
